module.exports = __webpack_public_path__ + "static/img/39.e5d5a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/39.jpg
// module id = Psa+
// module chunks = 1